const RELOAD_TIMESTAMP_KEY = 'chunk-reload-at';
const RELOAD_LOOP_WINDOW_MS = 10_000;

const DYNAMIC_IMPORT_ERROR_MARKERS = [
  'failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'importing a module script failed',
];

export const isDynamicImportError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  const normalized = message.toLowerCase();
  return DYNAMIC_IMPORT_ERROR_MARKERS.some((marker) => normalized.includes(marker));
};

export const reloadOnce = (): boolean => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_TIMESTAMP_KEY));
    if (last && Date.now() - last < RELOAD_LOOP_WINDOW_MS) {
      return false;
    }
    sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(Date.now()));
    window.location.reload();
    return true;
  } catch {
    return false;
  }
};
